import React from 'react';
import iconify from '../iconify';

const TargetIcon = ({customColor, ...props}) => (
  <svg
    width="1em"
    height="1em"
    viewBox="3105.279 221.29 54.475 54.237"
    {...props}
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1={1}
        y1={1}
        x2={0}
        y2={1}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#d3793b" />
        <stop offset={1} stopColor="#ea4154" />
      </linearGradient>
    </defs>
    <g transform="translate(3105.279 221.29)">
      <path
        fill={customColor ? 'currentColor' : 'url(#linear-gradient)'}
        d="M54.409 8.173a1.033 1.033 0 0 0-1-.619h-6.426V1.127a1.142 1.142 0 0 0-.619-1 1.312 1.312 0 0 0-1.238.238l-7.235 7.14a1.047 1.047 0 0 0-.286.809l-.1 7.093-1.805 1.81-.333-.286A21.111 21.111 0 0 0 21.373 11.6a21.349 21.349 0 1 0 21.373 21.325 21.079 21.079 0 0 0-5.141-13.9l-.286-.333 1.714-1.714h7.188a1.517 1.517 0 0 0 .809-.286l7.14-7.14a1.574 1.574 0 0 0 .239-1.379zm-13.9 24.753a19.136 19.136 0 1 1-19.136-19.089A18.685 18.685 0 0 1 33.845 18.5l.381.333-4.094 4.046-.332-.279a13.433 13.433 0 1 0 4.951 10.425 12.941 12.941 0 0 0-2.856-8.235l-.238-.333 4.043-4.051.333.381a18.746 18.746 0 0 1 4.476 12.138zm-19.85.9a1.289 1.289 0 0 0 1.618 0l2.475-2.475v1.571a3.38 3.38 0 1 1-3.38-3.38 2.435 2.435 0 0 1 .952.143l.571.286-2.237 2.237a1.149 1.149 0 0 0 0 1.618zm3.9-5.569l-.333-.143a5.629 5.629 0 1 0 2.761 4.855 6.128 6.128 0 0 0-.666-2.666l-.143-.286 4.046-4.046.333.476a11.26 11.26 0 1 1-9.14-4.713 11.031 11.031 0 0 1 6.759 2.285l.428.333zM39.748 8.839L44.7 3.888V8.22l-4.951 4.951zm5.95 5.95h-4.427l4.951-4.951h4.427z"
        transform="translate(0 -.062)"
      />
    </g>
  </svg>
);

export default iconify(TargetIcon);
